import axios from 'axios'
import store from "../store";
import ElementUI, {Loading} from 'element-ui'
import _ from 'lodash';


let http = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 300000
})

let recommendHttp = axios.create({
    baseURL: process.env.VUE_APP_RECOMMEND_URL,
    timeout: 30000
})

let iosHttp = axios.create({
    baseURL: process.env.VUE_APP_IOS_URL,
    timeout: 30000
})

let dogAdminHttp = axios.create({
    baseURL: process.env.VUE_APP_DESKTOP_DOG_ADMIN_URL,
    timeout: 30000
})

let womensAdminHttp = axios.create({
    baseURL: process.env.VUE_APP_WOMENS_ADMIN_URL,
    timeout: 30000
})

let womenUserHttp = axios.create({
    baseURL: process.env.VUE_APP_WOMEN_USER_URL,
    timeout: 30000
})

let outHttp = axios.create({
    baseURL: process.env.VUE_APP_OUT_URL,
    timeout: 300000
})

let settingHttp = axios.create({
    baseURL: process.env.VUE_APP_SETTING_URL,
    timeout: 30000
})

let financialHttp = axios.create({
    baseURL: process.env.VUE_APP_FINANCIAL_URL,
    timeout: 30000
})

let iosUserHttp = axios.create({
    baseURL: process.env.VUE_APP_IOS_USER_URL,
    timeout: 30000
})

let iosBookHttp = axios.create({
    baseURL: process.env.VUE_APP_IOS_BOOK_URL,
    timeout: 30000
})

let aiBookAdminHttp = axios.create({
    baseURL: process.env.VUE_APP_AI_BOOK_ADMIN_URL,
    timeout: 30000
})

let cgHttp = axios.create({
    baseURL: process.env.VUE_APP_CG_URL,
    timeout: 30000
})

let iosBookUserHttp = axios.create({
    baseURL: process.env.VUE_APP_IOS_BOOK_USER_URL,
    timeout: 30000
})

let aiBookUserHttp = axios.create({
    baseURL: process.env.VUE_APP_AI_BOOK_USER_URL,
    timeout: 30000
})

let cgUserHttp = axios.create({
    baseURL: process.env.VUE_APP_CG_USER_URL,
    timeout: 30000
})

let lcUserHttp = axios.create({
    baseURL: process.env.VUE_APP_LC_USER_URL,
    timeout: 30000
})

http.interceptors.request.use(config => {
    return reqSuccess(config);
})

iosHttp.interceptors.request.use(config => {
    return reqSuccess(config);
})

recommendHttp.interceptors.request.use(config => {
    return reqSuccess(config);
})
dogAdminHttp.interceptors.request.use(config => {
    return reqSuccess(config);
})

outHttp.interceptors.request.use(config => {
    return reqSuccess(config);
})

settingHttp.interceptors.request.use(config => {
    return reqSuccess(config);
})

financialHttp.interceptors.request.use(config => {
    return reqSuccess(config);
})

iosUserHttp.interceptors.request.use(config => {
    return reqSuccess(config);
})

iosBookHttp.interceptors.request.use(config => {
    return reqSuccess(config);
})

womensAdminHttp.interceptors.request.use(config => {
    return reqSuccess(config);
})

womenUserHttp.interceptors.request.use(config => {
    return reqSuccess(config);
})

aiBookAdminHttp.interceptors.request.use(config => {
    return reqSuccess(config);
})

cgHttp.interceptors.request.use(config => {
    return reqSuccess(config);
})

iosBookUserHttp.interceptors.request.use(config => {
    return reqSuccess(config);
})

aiBookUserHttp.interceptors.request.use(config => {
    return reqSuccess(config);
})

cgUserHttp.interceptors.request.use(config => {
    return reqSuccess(config);
})

lcUserHttp.interceptors.request.use(config => {
    return reqSuccess(config);
})

http.interceptors.response.use(data => {
    return resSuccess(data);
}, err => {
    return resError(err);
})

iosHttp.interceptors.response.use(data => {
    return resSuccess(data);
}, err => {
    return resError(err);
})

recommendHttp.interceptors.response.use(data => {
    return resSuccess(data);
}, err => {
    return resError(err);
})
dogAdminHttp.interceptors.response.use(data => {
    return resSuccess(data);
}, err => {
    return resError(err);
})

outHttp.interceptors.response.use(data => {
    return resSuccess(data);
}, err => {
    return resError(err);
})

settingHttp.interceptors.response.use(data => {
    return resSuccess(data);
}, err => {
    return resError(err);
})

womensAdminHttp.interceptors.response.use(data => {
    return resSuccess(data);
}, err => {
    return resError(err);
})

womenUserHttp.interceptors.response.use(data => {
    return resSuccess(data);
}, err => {
    return resError(err);
})

financialHttp.interceptors.response.use(data => {
    return resSuccess(data);
}, err => {
    return resError(err);
})

iosUserHttp.interceptors.response.use(data => {
    return resSuccess(data);
}, err => {
    return resError(err);
})

iosBookHttp.interceptors.response.use(data => {
    return resSuccess(data);
}, err => {
    return resError(err);
})

aiBookAdminHttp.interceptors.response.use(data => {
    return resSuccess(data);
}, err => {
    return resError(err);
})

cgHttp.interceptors.response.use(data => {
    return resSuccess(data);
}, err => {
    return resError(err);
})

iosBookUserHttp.interceptors.response.use(data => {
    return resSuccess(data);
}, err => {
    return resError(err);
})

aiBookUserHttp.interceptors.response.use(data => {
    return resSuccess(data);
}, err => {
    return resError(err);
})

cgUserHttp.interceptors.response.use(data => {
    return resSuccess(data);
}, err => {
    return resError(err);
})

lcUserHttp.interceptors.response.use(data => {
    return resSuccess(data);
}, err => {
    return resError(err);
})

function reqSuccess(config) {
    //判断当前请求是否设置了不显示Loading
    if (config.headers.showLoading !== false) {
        showLoading(config.headers.loadingTarget);
    }
    if (store.state.user.token) {
        config.headers.common.Authorization = store.state.user.token;
    }
    return config
}

function resSuccess(data) {
    //判断当前请求是否设置了不显示Loading（不显示自然无需隐藏）
    if (data.config.headers.showLoading !== false) {
        hideLoading();
    }
    if (data.data && data.data.status !== 0) {
        if (data.config.responseType !== 'arraybuffer') {
            ElementUI.Message({
                message: data.data.msg,
                type: "warning",
            })
        }
        if (data.data.status === -4) {
            location.assign("/#/login")
        }
    }
    return data
}

function resError(err) {
    hideLoading();
    let _message = ''
    if (err && err.response) {
        switch (err.response.status) {
            case 400:
                _message = '请求错误(400)';
                break;
            case 401:
                if (store.state.loginFlag.selectedLoginFlag === 0 || store.state.loginFlag.selectedLoginFlag === '0') {
                    store.commit('changeLoginFlag', 1);
                    ElementUI.Message({
                        message: '未授权，请重新登录(401)',
                        type: "error",
                        onClose: () => {
                            store.commit('changeLoginFlag', 0);
                        }
                    })
                    location.assign("/#/login")
                    return Promise.reject(err);
                } else {
                    console.log("重复提示错误忽略")
                }
                return;
            case 403:
                _message = '拒绝访问(403)';
                break;
            case 404:
                _message = '请求出错(404)';
                break;
            case 408:
                _message = '请求超时(408)';
                break;
            case 500:
                _message = '服务器错误(500)';
                break;
            case 501:
                _message = '服务未实现(501)';
                break;
            case 502:
                _message = '网络错误(502)';
                break;
            case 503:
                _message = '服务不可用(503)';
                break;
            case 504:
                _message = '网络超时(504)';
                break;
            case 505:
                _message = 'HTTP版本不受支持(505)';
                break;
            default:
                _message = `连接出错(${err.response.status})!`;
        }
    } else {
        _message = err
    }
    ElementUI.Message({
        message: _message,
        type: "error"
    })
    return Promise.reject(err)
}

//loading对象
let loading;

//当前正在请求的数量
let needLoadingRequestCount = 0;

//显示loading
function showLoading(target) {
    // 后面这个判断很重要，因为关闭时加了抖动，此时loading对象可能还存在，
    // 但needLoadingRequestCount已经变成0.避免这种情况下会重新创建个loading
    if (needLoadingRequestCount === 0 && !loading) {
        loading = Loading.service({
            lock: true,
            text: "Loading...",
            background: 'rgba(255, 255, 255, 0.5)',
            target: target || "body"
        });
    }
    needLoadingRequestCount++;
}

//隐藏loading
function hideLoading() {
    needLoadingRequestCount--;
    needLoadingRequestCount = Math.max(needLoadingRequestCount, 0); //做个保护
    if (needLoadingRequestCount === 0) {
        //关闭loading
        toHideLoading();
    }
}

//防抖：将 300ms 间隔内的关闭 loading 便合并为一次。防止连续请求时， loading闪烁的问题。
let toHideLoading = _.debounce(() => {
    loading.close();
    loading = null;
}, 300);

export {
    http,
    recommendHttp,
    iosHttp,
    outHttp,
    settingHttp,
    financialHttp,
    iosUserHttp,
    iosBookHttp,
    iosBookUserHttp,
    dogAdminHttp,
    cgHttp,
    cgUserHttp,
    aiBookUserHttp,
    aiBookAdminHttp,
    womensAdminHttp,
    womenUserHttp,
    lcUserHttp

}
